<template>
  <div class="MissionArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('ioDetails')">
      <div slot="top-action-view">
        <v-btn v-if="location" icon dark @click="showUserLocation"><v-icon>mdi-map</v-icon></v-btn>
      </div>
        <v-row class="pa-2">
          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.PageNo }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.PersonName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.RequestDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.RequestTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("date") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ClockDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("time") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ClockTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("requestType") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.Io }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.LastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("status") }}:</v-col>
              <v-col cols="9">
                <span
                  class="text-value"
                  v-text="
                    item.StatusType +
                    '-' +
                    (details.IsTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("description") }}:</v-col>
              <v-col cols="9">
                <span class="text-value">
                  {{ item.PersonName }}:{{ details.UserDescription }} <br />
                  <span
                    >تائید / رد کننده: {{ ApprovedPerson }}
                    {{ details.AdminDescription }}</span
                  >
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="imageResult">
            <v-row>
              <v-col cols="3">{{ $t("imageLocation") }}:</v-col>
              <v-col cols="9">
                <v-img
                :width="150"
                :max-height="250"
                :src="imageResult"
                ></v-img>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small v-if="visibleReturn" @click="ReturnRequest">{{
            $t("ReturnRequest")
          }}</v-btn>
          <v-btn small v-if="visibleReject" @click="RejectRequest">{{
            $t("RejectRequest")
          }}</v-btn>
          <v-btn small v-if="visibleApprove" @click="ApproveRequest">{{
            $t("ApproveRequest")
          }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="DeleteRequest">{{
            $t("DeleteRequest")
          }}</v-btn>
          <v-btn small v-if="visibleEdit" @click="EditRequest">{{
            $t("EditRequest")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow :pageNo="pageNo" :pageType="3" :year="year" />
        <user-location ref="UserLocation"/>
      </box>
    </v-dialog>
  </div>
</template>

<script>
import RequestState from "@/model/RequestState";
import ArchiveDetalsFlow from "../../request/ArchiveDetalsFlow.vue";
import TextUtils from "../../../utils/TextUtils";
import EosUtils from "../../../utils/EosUtils";
import ResultType from "../../../model/ResultType";
import UserLocation from '../../map/UserLocation.vue';

const initialData = () => {
  return {
    imageResult:"",
    visible: false,
    item: "",
    details: {
      PageNo: "",
    },
    visibleEdit: false,
    visibleDelete: false,
    visibleReject: false,
    visibleReturn: false,
    visibleApprove: false,
    ApprovedPerson: "",
    location:null,
   
  };
};

export default {
  components: { ArchiveDetalsFlow, UserLocation },
  props: {},
  computed: {
    pageNo() {
      if (this.item && this.item.PageNo) {
        return this.item.PageNo.toString();
      } else {
        return "";
      }
    },
    year() {
      if (this.item && this.item.ClockDate) {
        var y = this.item.ClockDate.toString().split("/")[0];
        //console.log(y);
        return Number(TextUtils.convertToEnglishDigits(y));
      } else {
        return "";
      }
    },
  },
  data() {
    return initialData();
    
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(item) {
      //console.log(item);
      debugger
      this.resetData();
      this.visible = true;
      this.item = item;
      this.GetIoDetail(item);
      this.GetIoPageLocation(item.PageNo);
    },
    hide() {
      debugger
      this.visible = false;
    },
    GetIoPageLocation(pageNo) {
      this.$store
        .dispatch("geolocation/GetIoPageLocation", {
          params: {
            pageNo: pageNo,
          },
        })
        .then((result) => {
          console.log(result);
          if(result.type == ResultType.success){
            debugger
            this.location = result.data[0];
            var aa=result.data[0].image;
            this.imageResult=aa;
          }
        });
    },
    GetIoDetail(item) {
      console.log(item);
      const params = new URLSearchParams();
      params.append("id", TextUtils.convertToEnglishDigits(item.PageNo));
      params.append(
        "year",
        TextUtils.convertToEnglishDigits(item.ClockDate.substr(0, 4))
      );

      this.$store.dispatch("GetIoDetail", { params }).then((result) => {
        //console.log(result);
        if (result.type == "success") {
          if (result.data.length > 0) {
            this.details = result.data[0];
            this.checkActionsVisiblity();
            this.getApprovedPerson();
          }
        }
      });
    },
    getApprovedPerson() {
      if (this.details.ApprovedBy.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.ApprovedBy.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.ApprovedBy.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      var params = new URLSearchParams();
      params.append(
        "pagePerno",
        TextUtils.convertToEnglishDigits(this.item.PageNo)
      );
      params.append(
        "section",
        TextUtils.convertToEnglishDigits(this.item.Section.trim())
      );
      params.append("status", this.item.Status);
      this.$store
        .dispatch("GetIoInfoDetailForAdmin", { params })
        .then((result) => {
          if (result.type === ResultType.success) {
            this.visibleEdit = result.data.Edit;
            this.visibleDelete = result.data.Delete;
            this.visibleReject = result.data.Reject;
            this.visibleReturn = result.data.Return;
            this.visibleApprove = result.data.Approve;
          }
        });
    },
    EditRequest() {
      this.hide();
      //console.log(this.details);
      //console.log(this.item);

      var vacationDetails = {
        Year: this.item.Year,
        PageNo: this.item.Pageno,
        Type: this.item.Type,
      };

      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({
          name: "admin-request-mission",
          params: { details: vacationDetails },
        });
      }
    },
    DeleteRequest() {
      this.operationOnRequest(RequestState.RequestState.Delete);
    },
    ReturnRequest() {
      this.operationOnRequest(RequestState.RequestState.Return);
    },
    RejectRequest() {
      this.operationOnRequest(RequestState.RequestState.Reject);
    },
    ApproveRequest() {
      this.operationOnRequest(RequestState.RequestState.Approve);
    },
    operationOnRequest(requestState) {
      var list = [this.item];
      this.$emit("operationOnRequest", requestState, list);
      this.hide();
    },
    showUserLocation(){
      this.$refs.UserLocation.show(this.location)
    }
  },
};
</script>

<style scoped>
*td {
  padding: 2px;
}
</style>